import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    onConfirm: () => void
    onCancel: () => void
}

const ExpireDonorModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Expire Donor Candidate</Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    Confirm that you want to expire donor <strong>{props.fullName}</strong>...
                </div>

                <Alert bsStyle='danger' bsSize='sm'>
                    This will set the current status to 'Manually Ruled Out' and set the Pre-Workup Lab step to 'Manually Expired'. The donor will not be able to re-register.
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ExpireDonorModal;